import React from 'react';
import PropTypes from 'prop-types';

import { FiArrowLeft } from 'react-icons/fi';
import { useHistory } from 'react-router';
import * as S from './styles';

const HeaderSimpleWithReturn = ({
  title, returnLink, rightAction, onClick, noMarginBottom, noHorizontalPadding,
}) => {
  const history = useHistory();
  // `returnLink` volta pelo history, do mesmo jeito que o resto do fluxo do
  // produto (Product/AddToCart). Era um <Link>, e dentro do painel ele nao
  // trocava a rota.
  const handleReturn = onClick || (returnLink ? () => history.push(returnLink) : null);

  return (
    <S.HeaderSimpleWithReturn
      noMarginBottom={noMarginBottom}
      rightAction={rightAction?.label}
      $noHorizontalPadding={noHorizontalPadding}
      // a barra inteira volta: dentro do Electron o alvo de 24px da seta falha
      onClick={handleReturn || undefined}
    >
      {handleReturn && (
        <button
          type="button"
          className="close"
          aria-label="Voltar"
        >
          <FiArrowLeft />
        </button>
      )}
      <span className="title">{title}</span>
      {rightAction?.label && (
        <button
          type="button"
          className="right-action"
          onClick={(event) => {
            // a acao da direita e propria: nao pode disparar o retorno da barra
            event.stopPropagation();
            rightAction.action();
          }}
        >
          {rightAction?.label}
        </button>
      )}
    </S.HeaderSimpleWithReturn>
  );
};

HeaderSimpleWithReturn.propTypes = {
  onClick: PropTypes.func,
  returnLink: PropTypes.string,
  noMarginBottom: PropTypes.bool,
  title: PropTypes.string.isRequired,
  noHorizontalPadding: PropTypes.bool,
  rightAction: PropTypes.shape({
    action: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
  }),
};

HeaderSimpleWithReturn.defaultProps = {
  onClick: null,
  returnLink: '',
  rightAction: {},
  noMarginBottom: false,
  noHorizontalPadding: false,
};

export default HeaderSimpleWithReturn;
